// @flow
import * as React from 'react';

export default function SpotIcon(): React.Element<'svg'> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139 139">
      <defs>
        <linearGradient id="gradient">
          <stop offset="0.5" stopColor="white" stopOpacity="1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <mask id="gradient-mask">
          <rect id="mask001" x="0" y="0" width="139" height="69" fill="url(#gradient)" />
          <rect id="mask002" x="68" y="0" width="69" height="139" fill="white" />
          <rect id="mask004" x="0" y="0" width="69" height="139" fill="black" />
          <rect id="mask003" x="0" y="0" width="69" height="139" fill="white" />
        </mask>
      </defs>
      <path
        mask="url(#gradient-mask)"
        fillOpacity="0"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
        d="M130.965 63.155c2.677 2.675 2.677 7.013 0 9.689l-58.141 58.132c-2.673 2.677-7.013 2.676-9.688 0L4.997 72.844c-2.677-2.676-2.677-7.014 0-9.689L63.136 5.022c2.675-2.675 7.015-2.675 9.688 0l58.141 58.133z"
      />
    </svg>
  );
}
